import { isObject, get, isNullOrUndefined, isNumber } from 'intact-shared';
var valueRegexp = /\{([^\}\s]+)\}/g;
var i18n = {};
export function _$(key, data) {
  if (isNullOrUndefined(key)) return;
  var value = get(i18n, key);
  if (isNullOrUndefined(value)) {
    value = key;
  }
  if (isNumber(value)) value = String(value);
  if (data) {
    value = value.replace(valueRegexp, function (nouse, variable) {
      var suffix;
      var index = variable.indexOf(':');
      if (index > 0) {
        suffix = variable.substr(0, index);
        suffix = suffix.split('|');
        variable = variable.substr(index + 1);
        variable = get(data, variable);
        if (variable > 1) {
          return suffix.length > 1 ? suffix[1] : suffix[0];
        } else {
          return suffix.length > 1 ? suffix[0] : '';
        }
      } else {
        variable = get(data, variable);
        return isNullOrUndefined(variable) ? nouse : variable;
      }
    });
  }
  return value;
}
export function localize(data) {
  if (!isObject(data)) {
    throw new Error("expect a object but got " + data);
  }
  i18n = data;
}